/** @format */

import React from "react";
import useHasClassrooms from "../hooks/useHasClassrooms";

const CourseClassroomIndicator = ({ courseId, asBadge = true }) => {
  const { hasClassrooms, loading } = useHasClassrooms(courseId);

  if (loading) {
    return asBadge ? (
      <span className="text-xs text-gray-400">Loading...</span>
    ) : null;
  }

  if (!hasClassrooms) {
    return asBadge ? <span className="text-xs text-gray-500">—</span> : null;
  }

  return asBadge ? (
    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
      <svg className="h-3 w-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 13l4 4L19 7"
        />
      </svg>
      Has Classrooms
    </span>
  ) : (
    <div className="text-xs text-green-700">Has Classrooms</div>
  );
};

export default CourseClassroomIndicator;


